import { apiFetch } from '../../../../api/api';

export default {
  data() {
    return {
      running: false,
      checkInterval: null,
      runId: null,
    };
  },
  props: {
    reportUrl: String,
    portfolio: Object,
  },
  methods: {
    run: function() {
      if (this.running) {
        return;
      }
      if (this.checkInterval) {
        window.clearInterval(this.checkInterval);
      }
      this.running = true;
      const [reportPath, reportSearch] = this.reportUrl.split('?');
      const qsArgs = new URLSearchParams(reportSearch);
      qsArgs.set('printing', 1);
      apiFetch(
          `/api/v1/process/report/${this.action}/`,
          {
            method: 'POST',
            headers: {
              'X-CSRFToken': this.$root.$data.csrfToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              report_url: `${reportPath}?${qsArgs}`,
              portfolio_id: this.portfolio.external_id || this.portfolio.id,
            }),
          },
      )
          .then((data) => {
            return data.json();
          })
          .then((data) => {
            this.runId = data.task.id;
            this.checkInterval = window.setInterval(() => {
              apiFetch(`/report-status/${this.runId}/`)
                  .then((data) => {
                    return data.json();
                  })
                  .then((data) => {
                    if (data.status) {
                      if (data.status === 'new') {
                        return;
                      }

                      window.clearInterval(this.checkInterval);
                      this.checkInterval = null;
                      this.running = false;

                      if (data.status === 'complete' && this.shouldDownload) {
                        window.location.href = `/download-report/${this.runId}/`;
                      }
                      if (data.status === 'error') {
                        alert('There was an error generating your PDF, please try again.');
                      }
                    }
                  });
            }, 2000);
          });
    },
  },
};
